import { Component } from 'react';

export class MastercardSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                width="70"
                height="40"
                viewBox="0 0 44 27"
                fill="none"
                data-testid="MastercardSVG"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.271946 0.524941V0.0899919H0.449459V0H0V0.0899919H0.192627V0.524941H0.271946ZM1.14443 0.524941V0H1.00846L0.849823 0.374958L0.691191 0H0.570325V0.524941H0.668524V0.131238L0.815826 0.472448H0.917806L1.06511 0.131238V0.528692L1.14443 0.524941Z"
                    transform="translate(42.4287 21.3379)"
                    fill="#F79E1B"
                />
                <path
                    d="M11.8975 0H0V21.2263H11.8975V0Z"
                    transform="translate(16.05 2.88574)"
                    fill="#FF5F00"
                />
                <path
                    d="M22.0009 13.5019C22.0009 16.0348 21.2829 18.5166 19.9292 20.6635C18.5755 22.8105 16.6406 24.5361 14.3456 25.6429C12.0507 26.7498 9.4884 27.1933 6.95157 26.9228C4.41474 26.6523 2.00576 25.6786 0 24.1131C1.61892 22.8501 2.92775 21.2385 3.82773 19.4C4.72772 17.5615 5.19535 15.5441 5.19535 13.5C5.19535 11.4559 4.72772 9.4385 3.82773 7.6C2.92775 5.7615 1.61892 4.14992 0 2.88686C2.00576 1.32138 4.41474 0.347737 6.95157 0.0772154C9.4884 -0.193306 12.0507 0.250213 14.3456 1.35707C16.6406 2.46394 18.5755 4.18948 19.9292 6.33646C21.2829 8.48344 22.0009 10.9652 22.0009 13.4981V13.5019Z"
                    transform="translate(21.999)"
                    fill="#F79E1B"
                />
                <path
                    d="M16.8056 13.5003C16.8034 11.4558 17.2698 9.43755 18.1696 7.59846C19.0694 5.75937 20.3789 4.14763 21.9989 2.8853C19.993 1.32031 17.5841 0.347138 15.0474 0.0770049C12.5107 -0.193128 9.94862 0.250676 7.65399 1.35769C5.35936 2.46471 3.42475 4.19029 2.07126 6.33719C0.717763 8.4841 0 10.9657 0 13.4984C0 16.0312 0.717763 18.5128 2.07126 20.6597C3.42475 22.8066 5.35936 24.5322 7.65399 25.6392C9.94862 26.7462 12.5107 27.19 15.0474 26.9199C17.5841 26.6497 19.993 25.6766 21.9989 24.1116C20.3794 22.8496 19.0702 21.2385 18.1704 19.4001C17.2707 17.5617 16.8039 15.5442 16.8056 13.5003Z"
                    transform="translate(0 0.00195312)"
                    fill="#EB001B"
                />
            </svg>
        );
    }
}
